export default "__VITE_ASSET__FWjsHcgI__"